// TODO: 要把登出功能元件化
import React from 'react'
import { Container, Button, Box,useDisclosure, useToast} from '@chakra-ui/react'
import { useDispatch } from 'react-redux';
import { MdBuild } from "react-icons/md"
import { BsQrCodeScan, BsBoxArrowRight} from "react-icons/bs";
import { useNavigate } from 'react-router-dom'
import './Home.css'
import Modal from '@Components/Modal';
import { resetScanRecord } from '../stores/scanRecord';
import { resetGoogleSetting } from '@/stores/googleSetting';
import { resetUserAll } from '@/stores/user';
import { state } from '@/assets/vender/funcodeDecoder';


const ToolIcon = () => {
  return (
    <Box 
      width='32px' 
      height='32px'
      fontSize='1.2rem'
      backgroundColor='#85bfae'
      borderRadius='50%'
      display='flex'
      justifyContent='center'
      alignItems='center'
    >
      <MdBuild />
    </Box>
  )
}

const ScanIcon = () => {
  return (
    <Box 
      width='32px' 
      height='32px'
      fontSize='1.2rem'
      backgroundColor='#525d73'
      borderRadius='50%'
      display='flex'
      justifyContent='center'
      alignItems='center'
    >
      <BsQrCodeScan />
    </Box>
  )
}

const LogoutIcon = () => {
  return (
    <Box 
      width='32px' 
      height='32px'
      fontSize='1.2rem'
      backgroundColor='#E53E3E' // 紅色背景，與按鈕顏色搭配
      borderRadius='50%'
      display='flex'
      justifyContent='center'
      alignItems='center'
    >
      <BsBoxArrowRight />
    </Box>
  )
}

const Home = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const toast = useToast();
  const { isOpen: logoutIsOpen, onOpen: logoutOnOpen, onClose: logoutOnClose } = useDisclosure()
  //登出
    async function logout() {
      const jwt = localStorage.getItem('_fa_jwt');
      const baseurii = 'https://funaccount.azurewebsites.net';
      
      // 如果沒有 JWT，無法正確呼叫登出 API
      if (!jwt) {
        return { success: false, message: '尚未登入或登入狀態已失效' };
      }
      
      try {
        // 呼叫登出 API
        const response = await fetch(`${baseurii}/api/v1/shinfox/Logout`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${jwt}`,
            'Content-Type': 'application/json; charset=UTF-8'
          }
        });
        
        try {
          // 嘗試解析 JSON 回應
          const json = await response.json();
          // console.log('登出 API 回應:', json);
          
          if (json.returnCode === 0) {
            try {
              // 處理 Redux 狀態清理
              dispatch(resetGoogleSetting());
              dispatch(resetScanRecord());
              dispatch(resetUserAll());
              
              // 使用 Promise 確保 setTimeout 完成
              return new Promise(resolve => {
                setTimeout(() => {
                  // 清除本地存儲
                  localStorage.removeItem('_fa_jwt');
                  localStorage.removeItem('_fa_btc');
                  localStorage.removeItem('_fa_did');
                  localStorage.removeItem('_fa_lit');
                  localStorage.removeItem('_fa_rem');
                  
                  // 同時清理狀態物件
                  state.btc = '';
                  state.jwt = '';
                  state.lit = '';
                  state.rem = 0;
                  state.did = '';
                  // 解析 Promise 並返回結果
                  resolve({ success: true, message: '登出成功' });
                }, 0);
              });
            } catch (dispatchError) {
              console.error('清除 Redux 狀態時出錯:', dispatchError);
              return { success: false, message: '登出過程中發生錯誤' };
            }
          } else {
            console.warn(`登出 API 回應異常 (${json.returnCode}): ${json.msg}`);
            return { success: false, message: json.msg || '登出失敗，請稍後再試' };
          }
        } catch (jsonError) {
          // JSON 解析錯誤
          console.error('解析登出 API 回應時出錯:', jsonError);
          return { success: false, message: '處理伺服器回應時出錯' };
        }
      } catch (err) {
        // 網路錯誤或其他異常
        console.error('登出 API 呼叫失敗:', err);
        return { success: false, message: `登出請求失敗: ${err.message}` };
      }
    }
    
    // 處理登出按鈕的點擊事件
    const handleLogout = async () => {
      try {
        // 關閉登出確認對話框
        logoutOnClose();
        
        // 調用登出函數並等待完成
        const result = await logout();
        
        if (result.success) {
          toast({
            title: '登出成功',
            description: result.message,
            status: 'success',
            duration: 2000,
            position: 'top',
            isClosable: true,
          });
          
          // 所有操作完成後導航到登入頁面
          navigate('/login');
        } else {
          toast({
            title: '登出失敗',
            description: result.message,
            status: 'error',
            duration: 3000,
            position: 'top',
            isClosable: true,
          });
        }
      } catch (error) {
        console.error('登出過程中發生錯誤:', error);
        toast({
          title: '發生錯誤',
          description: '登出過程中發生意外錯誤',
          status: 'error',
          duration: 3000,
          position: 'top',
          isClosable: true,
        });
      }
    };
  return (
    <div className='home'>
       {/* 登出確認 MODAL */}
       <Modal 
        isOpen={logoutIsOpen}
        onClose={logoutOnClose}
        header={<>      
          <div style={{ 
            width: '65px', 
            height: '65px',
            borderRadius: '50%', 
            backgroundColor: '#E53E3E', // 使用紅色背景
            color: 'white',
            margin: '1rem auto',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
            }}
          >
            <BsBoxArrowRight style={{ fontSize: '2rem'}}/>
          </div>
          <h2 style={{ textAlign: 'center' }}>確認登出</h2>
        </>}
          ctaBtnText="確認登出"
          secondaryBtnText="取消"
          ctaBtnColor="red" // 設置按鈕為紅色
          ctaHandler={() => {
            handleLogout();
          }}
          secondaryHandler={logoutOnClose}
      >
        <p style={{ textAlign: 'center', fontSize: '1rem',}}>
          登出將會清除本機所有資料，是否確認登出?
        </p>
      </Modal>
      <div className='navbar'>
        <p style={{color: 'white', fontSize: '1.5rem'}}>Funcode</p>
      </div>
      <Container pt='3rem'>
        <div className='btns-wrap'>
          <h2 className='title'>方碼資產盤點</h2>
          <Button
            leftIcon={<ToolIcon />} 
            className='myBtn'
            colorScheme='blackAlpha'
            onClick={() => navigate('/setting')}
          >
            系統設定
          </Button>
          <Button 
            leftIcon={<ScanIcon />}
            className='myBtn'
            colorScheme='blackAlpha'
            onClick={() => navigate('/scan')}
          >
            盤點掃描
          </Button>
          <Button 
            leftIcon={<LogoutIcon />}
            className='myBtn'
            colorScheme='blackAlpha'
            onClick={logoutOnOpen}
          >
            登出系統
          </Button>
        </div>
      </Container>
    </div>
  )
}

export default Home